import { render, staticRenderFns } from "./VerifyView.vue?vue&type=template&id=33fcb88a&scoped=true"
import script from "./VerifyView.vue?vue&type=script&lang=js"
export * from "./VerifyView.vue?vue&type=script&lang=js"
import style0 from "./VerifyView.vue?vue&type=style&index=0&id=33fcb88a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fcb88a",
  null
  
)

export default component.exports